import { relativeTime, detectLang } from '../lib/rtl';
import { STRINGS } from '../lib/i18n';

export type FeedItem = {
  sid: string;
  display_name: string;
  question: string;
  answer_summary: string;
  mode: 'A' | 'B' | 'refused';
  ts: number;
};

const modeStyles: Record<FeedItem['mode'], { label: string; className: string }> = {
  A: { label: 'تاريخي', className: 'bg-tatweer-navy/10 text-tatweer-navy ring-1 ring-tatweer-navy/20' },
  B: { label: 'تحليل', className: 'bg-tatweer-green-50 text-tatweer-green-600 ring-1 ring-tatweer-green/30' },
  refused: { label: 'خارج النطاق', className: 'bg-tatweer-light text-tatweer-muted ring-1 ring-tatweer-line' },
};

export function LiveFeed({ items }: { items: FeedItem[] }) {
  if (!items.length) {
    return (
      <div className="rounded-2xl bg-white ring-1 ring-tatweer-line shadow-card p-6 text-tatweer-muted text-sm">
        {STRINGS.dashboard.feedEmpty.ar}
      </div>
    );
  }
  return (
    <ul className="space-y-2 max-h-[360px] overflow-y-auto pe-2 tatweer-scroll">
      {items.map((item) => {
        const qLang = detectLang(item.question);
        const sty = modeStyles[item.mode];
        return (
          <li key={`${item.sid}-${item.ts}`} className="rounded-xl bg-white ring-1 ring-tatweer-line shadow-card p-4 animate-fade-in">
            <div className="flex items-center justify-between gap-2 mb-2">
              <div className="flex items-center gap-2 min-w-0">
                <span className="inline-flex h-8 w-8 rounded-full bg-tatweer-navy text-white items-center justify-center text-sm font-semibold flex-shrink-0">
                  {item.display_name.slice(0, 1).toUpperCase()}
                </span>
                <span className="font-medium text-tatweer-body truncate">{item.display_name}</span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${sty.className}`}>{sty.label}</span>
                <span className="text-xs text-tatweer-muted">{relativeTime(item.ts, 'ar')}</span>
              </div>
            </div>
            <div className="text-sm text-tatweer-body bidi-plaintext leading-relaxed" dir={qLang === 'ar' ? 'rtl' : 'ltr'}>
              {item.question.length > 160 ? item.question.slice(0, 160) + '…' : item.question}
            </div>
            {item.answer_summary && (
              <div className="mt-2 text-xs text-tatweer-muted bidi-plaintext line-clamp-2 leading-relaxed">
                ← {item.answer_summary}
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
